import {
    getMenuList,
} from "@/api/api";

//获取菜单信息
export async function getMenuInfo(codes = {}, menuList) {
    let page = {}
    let list = []
    let res = '';
    if (menuList) {
        list = menuList
    }
    else {
        res = await getMenuList();
        if (res.code === 0) {
            list = res.page
        }
    }
    if (codes.code1) {
        page = list.find(item => {
            return item.code == codes.code1
        })
        if (codes.code2) {
            page = page.children.find(item => {
                return item.code == codes.code2
            })
        }
    }

    return page

}

export function dateToTime(date, get_date = false) {
    if(!date){
        return ''
    }
    let d = new Date(date)
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let days = d.getDate()

    month = month < 10 ? '0' + month : month
    days = days < 10 ? '0' + days : days

    let hour = d.getHours()
    let minute = d.getMinutes()
    let second = d.getSeconds()
    hour = hour < 10 ? '0' + hour : hour
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    if (get_date) {
        return year + '-' + month + '-' + days
    } else {
        return year + '-' + month + '-' + days + ' ' + hour + ':' + minute + ':' + second
    }
}


export function stampToTime(stamp, nowStamp, maxDay = 7) {
    let maxSecond = maxDay * (3600 * 24) // 天数的描述
    let monthStamp = 3600 * 24 * 30
    let weekStamp = 3600 * 24 * 7
    let twoWeekStamp = 3600 * 24 * 17
    let dayStamp = 3600 * 24
    let hourStamp = 3600
    let momentTime = 60 * 5 // 刚刚 5分钟前

    let struleStamp = Math.floor((nowStamp - stamp) / 1000)

    const dealTime = function (time_stamp) {
        let newStamp = time_stamp / 1000
        // return formatTimeTwo(newStamp, 'Y-M-D')
        let date = new Date(parseFloat(time_stamp))
        let year = date.getFullYear()
        let nowYear = new Date().getFullYear()
        if (year == nowYear) {
            return formatTimeTwo(newStamp, 'M-D')
        } else {
            return formatTimeTwo(newStamp, 'Y-M-D')
        }


        let month = date.getMonth() + 1
        let day = date.getDate()
        month = month < 10 ? '0' + month : month
        day = day < 10 ? '0' + day : day
        return year + '-' + month + '-' + day
    }
    if (struleStamp < maxSecond) {
        /* maxDay时间内 */

        if (struleStamp < monthStamp) {
            if (struleStamp < weekStamp) {
                if (struleStamp < dayStamp) {
                    /* 一天内 */
                    if (struleStamp < hourStamp) {
                        /* 一个小时内容 */
                        if (struleStamp < momentTime) {
                            return '刚刚'
                        }
                        return Math.ceil(struleStamp / 60) + '分钟前' // 分钟
                    }
                    return Math.floor(struleStamp / 3600) + '小时前'
                }
                return Math.floor(struleStamp / (3600 * 24)) + '天前'
            }
            return Math.floor(struleStamp / weekStamp) + '周前'
        }
        return Math.floor(struleStamp / monthStamp) + '月前'
    } else {
        return dealTime(stamp)
    }
}

export function movePlace(e) {
    document.getElementById(e).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
    });
}

export function listGetName(list, val){
    let name = ''
    list.forEach((item, index)=>{
        if(item.value == val){
            name = item.name
            return 
        }
    })
    return name
}


// WEBPACK FOOTER //
// ./src/utils/fc.js